import './custom-bootstrap.scss'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

serviceWorkerRegistration.register()
